/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components

// Material Kit 2 React components
import MKBox from "../../components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "../../views/Navbars/DefaultNavbar";

// Routes
// eslint-disable-next-line import/no-cycle
import routes from "../../routes";
import Breadcrumbs from "../../views/Breadcrumbs";
import DefaultFooter from "../../views/Footers/DefaultFooter";
import footerRoutes from "../../footer.routes";

function MainLayout({ children, breadcrumbsRoutes, rightComponent }) {
  return (
    <>
      <MKBox
        display="flex"
        flexDirection="column"
        bgColor="white"
        minHeight="100vh"
        maxHeight="100vh"
      >
        <MKBox bgColor="white" sx={{ zIndex: 1, height: "7vh" }}>
          <DefaultNavbar routes={routes} relative transparent />
        </MKBox>

        <MKBox width={1}>
          <MKBox
            sx={{
              background: ({ palette: { primary }, functions: { rgba } }) =>
                `${rgba(primary.main, 0.1)}`,
              display: "flex",
              height: "5vh",
              alignItems: "center",
            }}
          >
            <Breadcrumbs routes={breadcrumbsRoutes} />
            {rightComponent}
          </MKBox>
          <MKBox bgColor="white">{children}</MKBox>
        </MKBox>
      </MKBox>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}
MainLayout.defaultProps = {
  rightComponent: null,
};

// Typechecking props for the BaseLayout
MainLayout.propTypes = {
  breadcrumbsRoutes: PropTypes.arrayOf(PropTypes.any).isRequired,
  children: PropTypes.node.isRequired,
  rightComponent: PropTypes.node,
};

export default MainLayout;
